import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fetchAnnouncements,
  fetchUnhandledActivitiesCount,
  fetchNotifications
} from '../../app/actions'
import {
  setI13nData,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../app/actions/common'
import { withRouter } from 'react-router-dom'
import HorizontalLayout from '../components/Common/HorizontalLayout'
import { withI13nWrapper, withI13nHistoryListener } from '../components/Common/I13nWrapper'
import _ from 'lodash'

const mapStateToProps = (state, ownProps) => {
  return {
    env: state.page.env,
    i13nData: state.page.i13nData || {},
    supplier: state.supplier,
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setI13nData,
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    fetchAnnouncements,
    fetchUnhandledActivitiesCount,
    fetchNotifications
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

const connected = WrappedComponent => connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedComponent)

const hoc = _.flow([
  withI13nHistoryListener, // first wrap
  withI13nWrapper,
  connected,
  withRouter
])

export default hoc(HorizontalLayout)
